export const GET_USERS_SUPPLIES = 'GET_USERS_SUPPLIES';
export const SET_USERS_SUPPLIES = 'SET_USERS_SUPPLIES';
export const GET_ASSETS_TO_SUPPLY = 'GET_ASSETS_TO_SUPPLY';
